import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { useLanguage } from '../lib/LanguageContext';

const ContactCTA = () => {
  const { t } = useLanguage();

  return (
    <section className="py-12 md:py-16 lg:py-20 relative overflow-hidden bg-slate-900 border-t border-slate-800">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img 
          src="/images/metalwork.jpg" 
          alt="Metalwork Workshop" 
          className="w-full h-full object-cover opacity-20 brightness-50"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900 via-transparent to-slate-900" />
        <div className="absolute inset-0 bg-radial-at-tr from-[#f59c01]/10 via-transparent to-transparent" />
        <div className="absolute inset-0 bg-radial-at-bl from-[#f59c01]/5 via-transparent to-transparent" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-8 border-l-4 border-[#f59c01] pl-4 inline-block">
          {t.ui.ctaTitle}
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center sm:items-start gap-6 md:w-1/2">
          <a 
            href={`tel:${t.phone.replace(/\s+/g, '')}`}
            className="group flex items-center space-x-4 bg-[#f59c01] text-white px-5 py-3 md:px-10 md:py-5 rounded-2xl font-bold text-base md:text-xl hover:bg-[#e08e01] transition-all shadow-xl hover:shadow-[#f59c01]/20 hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            <Phone className="w-5 h-5 md:w-6 md:h-6 group-hover:rotate-12 transition-transform" />
            <span>{t.hero.cta_call}</span>
          </a>
          <a 
            href={`mailto:${t.email}`}
            className="group flex items-center space-x-4 bg-white/10 backdrop-blur-md border-2 border-white/20 text-white px-5 py-3 md:px-10 md:py-5 rounded-2xl font-bold text-base md:text-xl hover:bg-white/20 transition-all hover:-translate-y-1 w-full sm:w-auto justify-center"
          >
            <Mail className="w-5 h-5 md:w-6 md:h-6 group-hover:-rotate-12 transition-transform" />
            <span>{t.hero.cta_email}</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ContactCTA;
